import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import Iframe from 'react-iframe';
import moment from 'moment';
import RaisedButton from 'material-ui/RaisedButton';
import { base64Encode, GetReportUrl, IS_REPORT_ORGANISED } from '../../../../actions/utilAction';
import { renderAutoCompleteScheduling, renderAutoCompleteSingleSelect, renderCheckBox, renderDateField } from '../../../../components/reduxFields';
import Loader from '../../../../img/loader.gif';
import { getMasterData } from '../../actions/index';
import history from '../../../../history';

// const validate = (values) => {
//   const errors = {};
//   if (!values.location) {
//     errors.location = 'Please select location.';
//   }  
  
//   return errors;
// };

const styles = {
  font: {
    fontStyle: 'ITALIC',
  },
};

class ProfitReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      organizationID: this.props.orgID,
      access_token: this.props.access_token,
      FromDate: new Date().setDate(new Date().getDate() - 6),
      ToDate: new Date(),
      // iframeURL: `${REPORT_URL}?%2fHC.SqlReports%2fProfitReport&rs:Command=Render&rs:embed=true&OrganizationID=` + this.props.orgID + '&LocationID=' + this.props.locationID,
      iframeURL: '',
      isLoading: false,
      random: 0,
      isDriveTime: 0,
      isMileage: 0,
      isPaidBreak: 0,
    };
    this.onDateChange = this.onDateChange.bind(this);
    this.appointmentFilterByDate = this.appointmentFilterByDate.bind(this);
    this.checkDriveTimeSearch = this.checkDriveTimeSearch.bind(this);
    this.checkMileageSearch = this.checkMileageSearch.bind(this);
    this.checkPaidBreakSearch = this.checkPaidBreakSearch.bind(this);
  }

  componentWillMount() {      
    let masterData = {
      'masterdata': 'MASTERALLSTAFF,APPOINTMENTTYPE',
    };    
     this.props.getMasterData(masterData);    

    
  }

  // onDateChange = (input, value) => {
  //   input.onChange(moment(value).format());
  //   this.setState({
  //     [input.name]: value,
  //   });
  // }

  onDateChange = (input, value, action) => {
    input.onChange(moment(value).format());

    if(action === "FromDate")
    {
      this.setState({
        [input.name]: value,
       //ToDate: moment(value,'YYYY-MM-DD').add(6, 'days'),
      });
    }
    else
    {
      this.setState({
        //FromDate: moment(value,'YYYY-MM-DD').subtract(6, 'days'),
        [input.name]: value,
      });
    }
}

  appointmentFilterByDate = (formData) => {
    this.resetIframe();

    let FromDateFormat;
    let ToDateFormat;
    // console.log('formData.legth---', Object.keys(formData).length);
    if (Object.keys(formData).length) {
      FromDateFormat = moment(this.state.FromDate).format('YYYY-MM-DD');
      ToDateFormat = moment(this.state.ToDate).format('YYYY-MM-DD');
    } else {
      let DateFormat = new Date().setDate(new Date().getDate() - 7);
      FromDateFormat = moment(DateFormat).format('YYYY-MM-DD');
      let dateFormat = new Date();
      ToDateFormat = moment(dateFormat).format('YYYY-MM-DD');
    }
    let REPORT_URL  = GetReportUrl(this.props.agencyName);  
    let reportName = base64Encode('FC_ProfitReport');
    this.setState({
      isLoading: true,
      iframeURL: `${REPORT_URL}?Params=[{"Name": "AGENT","Value": "`+ base64Encode(this.state.organizationID.toString()) + `"},{"Name": "FromAppointmentDate","Value": "`+ FromDateFormat + `"},{"Name": "ToAppointmentDate","Value": "`+ ToDateFormat + `"},{"Name": "LocationID","Value": "`+ (formData.location || 0) + `"},{"Name": "StaffIds","Value": "`+ (formData.staffIds && formData.staffIds.length > 0 ? formData.staffIds : 0) + `"},{"Name": "AppointmentTypeIds","Value": "`+ (formData.appointmentTypeIds && formData.appointmentTypeIds.length > 0 ? formData.appointmentTypeIds : 0) + `"},{"Name": "IsMileage","Value": "` + this.state.isMileage + `"},{"Name": "IsDriveTime","Value": "` + this.state.isDriveTime + `"},{"Name": "IsPaidBreak","Value": "` + this.state.isPaidBreak + `"},{"Name": "Offset","Value": "`+ moment().utcOffset() + `"}]&AccessToken=` + this.state.access_token + `&ReportName=` + reportName,
    });
  }

  onLoadReport = (e) => {
    this.setState({ isLoading: false});
  }

  resetIframe() {
    this.setState({random: this.state.random + 1});
  }
  
  renderReport() {
    return (
      <Iframe url={this.state.iframeURL}
        // width="450px"
        height="580px"
        id="myId"
        className="manual_report"
        display="initial"
        position="relative"
        onLoad={(e)=> this.onLoadReport(e)}
        key={this.state.random}
        allowFullScreen />
    );
  }

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  }
  
  handleChange = (input, selectedRecord) => {
    //if (input.name === 'staffIds') {
      input.onChange(selectedRecord);
    //}
    // else{
    //   input.onChange(selectedRecord.value);
    //   this.props.GetStaffByLocation(selectedRecord.value, 'YES')
    // }
  }

  checkDriveTimeSearch = (e, name) => {
    if (name === 'isDriveTime' && e.target.checked) {
      this.setState({isDriveTime : 1});
    }
    else if (name === 'isDriveTime' && !e.target.checked) {
      this.setState({isDriveTime : 0});
    } 
  }

  checkMileageSearch = (e, name) => {
    if (name === 'isMileage' && e.target.checked) {
      this.setState({isMileage : 1});
    }
    else if (name === 'isMileage' && !e.target.checked) {
      this.setState({isActive : 0});
    } 
  }

  checkPaidBreakSearch = (e, name) => {
    if (name === 'isPaidBreak' && e.target.checked) {
      this.setState({isPaidBreak : 1});
    }
    else if (name === 'isPaidBreak' && !e.target.checked) {
      this.setState({isPaidBreak : 0});
    } 
  }

  renderLoading() {
    if (this.state.isLoading) {
      return (
        <div className="full_loader">
          <div className="circle_loader page_loader">
            <img src={Loader} alt="" />
          </div>
        </div>
      );
    }
  }
  onBackClick = () => {
    history.push('/reports/financial-reports');
  }
  render() {
    const { handleSubmit } = this.props;
    //   let iframeUrl = `${REPORT_URL}?%2fHC.SqlReports%2fProfitReport&rs:Command=Render&rs:embed=true&OrganizationID=` + this.state.organizationID + '&LocationID=' + this.state.locationID;
    // let windowsHeight = window.innerHeight + 159 + "px";
    // console.log(windowsHeight);
    return (
      <div>
        {this.renderLoading()}
        {IS_REPORT_ORGANISED === 'YES' ?
          <h2 className="page_title">Financial {' > '} Profit Report</h2>
        :
          <h2 className="page_title">Profit Report</h2>
        } 
        <div className="clearfix"></div>
        <div className="readmin-panel">
          <div className="panel-body">    
          {IS_REPORT_ORGANISED === 'YES' &&       
              <div className="modalwindow">
                  <div className="row">
                      <div className="col-sm-2">
                          <RaisedButton label="Back" primary={true} onTouchTap={() => this.onBackClick()} />
                      </div>
                  </div>
              </div>} 
            <div className="panel_title">
              <h7 style={styles.font}>*Please enter payroll rates before running this report. The amounts in the “billed” column of this report include claims in the ready to bill area.</h7>                    
            </div>       
            <form className="readmin-form custom_form" onSubmit={handleSubmit(this.appointmentFilterByDate)}>
              <div className="row">
                <div className="col-sm-3">
                  <Field name="FromDate"
                    placeholder="From Date"
                    locale="en-US"
                    selected={this.state.FromDate}
                    //onDateChange={this.onDateChange}
                    onDateChange={(input, value) => this.onDateChange(input, value, 'FromDate')}
                    openToYearSelection={true}
                    component={renderDateField} />
                </div>
                <div className="col-sm-3">
                  <Field name="ToDate"
                    placeholder="To Date"
                    locale="en-US"
                    minDate = {this.state.FromDate}
                    selected={this.state.ToDate}
                    openToYearSelection={true}
                    //onDateChange={this.onDateChange}
                    onDateChange={(input, value) => this.onDateChange(input, value, 'ToDate')}
                    component={renderDateField} />
                </div>
                <div className="col-sm-3 mt-35">
                  <Field name="location"
                    label="Location"
                    handleNewRequest={this.handleNewRequest}
                    options={this.props.userLocationList}
                    component={renderAutoCompleteSingleSelect}
                  />
                </div>
                <div className="col-sm-3 mt-35">
                    <Field name="staffIds"
                      label="Staff"
                      handleNewRequest={this.handleChange}
                      options={this.props.allStaffs}
                      component={renderAutoCompleteScheduling}
                    />
                </div> 
                <div className="col-sm-3 mt-35">
                    <Field name="appointmentTypeIds"
                      label="Appointment Type"
                      handleNewRequest={this.handleChange}
                      options={this.props.appointmentType}
                      component={renderAutoCompleteScheduling}
                    />
                </div>  
                <div className="col-sm-3 mt-20">
                    <Field
                      className="mt20 mb0"
                      name="isDriveTime"
                      label="Include Drive Time"
                      onChange={(e) => this.checkDriveTimeSearch(e, 'isDriveTime')}
                      component={renderCheckBox}
                    />
                </div>
                <div className="col-sm-3 mt-20">
                    <Field
                      className="mt20 mb0"
                      name="isMileage"
                      label="Include Mileage"
                      onChange={(e) => this.checkMileageSearch(e, 'isMileage')}
                      component={renderCheckBox}
                    />
                </div>
                <div className="col-sm-3 mt-20">
                    <Field
                      className="mt20 mb0"
                      name="isPaidBreak"
                      label="Include Paid 10 Min Break"
                      onChange={(e) => this.checkPaidBreakSearch(e, 'isPaidBreak')}
                      component={renderCheckBox}
                    />
                </div>    
                <div className="col-sm-3 btn_lt reset-btn mt-25">
                  <RaisedButton className="grey_btn" type="Submit" primary={true}>Generate</RaisedButton>
                </div>
              </div>
            </form>
          </div>
        </div>
        {this.renderReport()}
      </div>
    );
  }
}

ProfitReport = reduxForm({
  form: 'ProfitReportForm',
  //validate,
})(ProfitReport);

function mapStateToProps(state) {
  let locationArr = [];
  if (state.login.userLocationList) {
    locationArr = (state.login.userLocationList).map((obj) => {
      return (
        {
          id: obj.id,
          value: obj.locationName,
        }
      );
    });
  }

  return {
    orgID: state.login.loginUserInfo.organizationID,
    userLocationList: locationArr,
    access_token: state.login.access_token,
    allStaffs : state.report.master_data ? state.report.master_data.allStaffs : [],
    appointmentType : state.report.master_data ? state.report.master_data.appointmentType : [],
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
export default connect(mapStateToProps, {getMasterData})(ProfitReport);



// WEBPACK FOOTER //
// ./src/modules/Reports/components/FinancialReports/ProfitReport.js